module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nancy Springer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nancy Springer is the award-winning author of more than fifty books, including the Enola Holmes and Rowan Hood series and a plethora of novels for all ages, spanning fantasy, mystery, magic realism, and more. She received the James Tiptree, Jr. Award for "), _c('I', [_vm._v("Larque on the Wing")]), _vm._v(" and the Edgar Award for her juvenile mysteries "), _c('I', [_vm._v("Toughing It ")]), _vm._v("and "), _c('I', [_vm._v("Looking for Jamie Bridger")]), _vm._v(", and she has been nominated for numerous other honors. Springer currently lives in the Florida Panhandle, where she rescues feral cats and enjoys the vibrant wildlife of the wetlands."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hq5yFX/images/MyCoverImage.jpg?1701092217348",
      "alt": "This image is the cover for the book Possessing Jessie"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Possessing Jessie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When Jessie’s brother dies, something takes hold of her in this chilling supernatural story of guilt, possession, and obsession")]), _c('br'), _c('br'), _vm._v(" Jessie wakes up knowing exactly what she needs to do. Gazing at her reflection in the bathroom mirror, she begins cutting off her beautiful locks, leaving herself with a short, boyish cut—just like her brother’s."), _c('br'), _c('br'), _vm._v(" Jason died in a car crash, and since the funeral, Jessie hasn’t been the same. Now, wearing her brother’s clothes, her hair spiked just the way he used to wear his, she can face herself again. But what starts out as a difficult grieving process becomes something much more serious. Before long, she is sleeping in his bedroom, talking like him, even hearing his voice in her head. She is no longer just acting like Jason . . . she is starting to become him. \n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0